import api from "api";

const features = {
    flags: () => {
        return api().get('/feature-toggle');
    },
};
 
export default features;  